<template lang="pug">
  div
    div
    b-container.content.page-container
      b-row.header
        div
          img(src="../../../assets/logo_big.png")
        div.button-wrapper
          b-dropdown(text="메뉴" right variant="primary")
            b-dropdown-item 홈
            b-dropdown-item 사용 신청
            b-dropdown-item 원격 제어
            b-dropdown-item 이력 관리
            b-dropdown-item 정보 변경
      b-row.title
        div 파트너 원격
      b-row.select-mode
        div.partner-mode.centered-content(@click="handlePartnerModeClick")
          span 사용 신청
        div.temporary-mode.centered-content(@click="handleTemporaryModeClick")
          span 원격 제어
      b-row.select-mode
        div.temporary-mode.centered-content(@click="handlePartnerModeClick")
          span 이력 관리
        div.partner-mode.centered-content(@click="handleTemporaryModeClick")
          span 정보 변경
      b-row.footer
        div.centered-content
          span COPYRIGHT 20232. KOINO Inc. all rights reserved.

</template>

<script>

export default {
  name: 'partner-index',
  methods: {
    handlePartnerModeClick() {
      this.$router.push('partner-login')
    },
    handleTemporaryModeClick() {
      this.$router.push('email-invitation')
    },
  },
  mounted() {
    // console.log("temporary-login Mounted")
  },
  data() {
    return {

    }
  }
}
</script>


<style scoped lang="scss">
.page-container {
  padding-top: 2rem;
}

.header {
  justify-content: center;
  margin-bottom: 2rem;

  img {
    width: 17rem;
  }

  .button-wrapper {
    position: absolute;
    right: 0;
    top: 53px;
    margin: 1rem;
  }
}

.title {
  justify-content: center;
  margin: 1rem 0 0 0;

  > div {
    font-size: 2rem;
    font-weight: 550;
    letter-spacing: 1px;
  }
}

.select-mode {
  justify-content: center;
  > div {
    width: 15rem;
    height: 13rem;
    margin: 1rem;
    border-radius: 3rem;
    cursor: pointer;
    > span {
      color: white;
      font-size: 1.3rem;
      font-weight: 550;
    }
  }
}

.partner-mode {
  background: #fd7e14;
}

.temporary-mode {
  background: #7d7d7d;
}

.mode-explanation {
  justify-content: center;
  margin-top: 0.5rem;
  > div {
    width: 25rem;
    margin: 0 1rem;
  }
  span {
    font-size: 1.2rem ;
  }
}

.centered-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer {
  justify-content: center;
  margin-top: 10rem;
  span {
    font-size: 0.9rem;
    font-weight: 350;
    letter-spacing: 2px;
  }
}
</style>
